import React, { useState, useEffect } from "react";
import Alert from "@mui/material/Alert";

const NtError = (props) => {
  const [useDisplay, setDisplay] = useState(props.testState);
  const styles = {
    width: "100%",
    maxWidth: 300,
    borderRadius: "4px",
    padding: "8px 30px",
    fontWeight: 600,
    textAlign: "left",
    color: "#ffd0d0",
    zIndex: 9999,
    marginLeft: "auto",
    marginRight: "auto",
  };
  useEffect(() => {
    setTimeout(() => {
      setDisplay("d-none");
    }, 5000);
  }, [useDisplay]);
  //error
  //info
  //warning
  //success
  switch (props.errorType) {
    case "Submitted":
      return (
        <Alert variant="filled" className="Global_error s" severity="info">
    Submitted Successfully
        </Alert>
      );
      break;
    case "Not Submitted":
      return (
        <Alert variant="filled" className="Global_error" severity="error">
    Your Form Is Not Submitted Please Fill all the Fields
        </Alert>
      );
      break;
    default:
      return <span />;
      break;
  }
};

export default NtError;
